<div class="m-content">
  <div class="row">
    <div class="col-lg-12">
      <div class="dashboard">
        <div class="row">
          <div class="dashboad-title">
            <p class="header-item">{{title}}</p>
            <p class="sub-title">{{description}}</p>
          </div>
        </div>
        <div class="row">
          <div class="dashboard-card">
            <app-dashboard-card *ngFor="let card of dashboardCards" [title]="card.title" [description]="card.description" [logoUrl]="card.logoUrl"
              [route]="card.route" [relative]="card.relative" [queryParams]="card.queryParams" [queryParamsOriginal]="card.queryParamsOriginal" [cardWidth]="card.cardWidth" [setOwnCardWidth]="card.setOwnCardWidth" [link]="card.link" [hyperLink]="card.hyperLink"></app-dashboard-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
